import { inject } from '@angular/core';
import { CanActivateFn, CanDeactivateFn } from '@angular/router';
import { Store } from '@ngrx/store';

import * as fromStore from '../store';
import { catchError, filter, map, of, switchMap, take, tap } from 'rxjs';
import { ResetMenuTheme, SetMenuTheme } from 'src/app/store';

export const LandingPageHeaderThemeGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);

  return store
    .select(fromStore.getSelectedLandingPage)
    .pipe(
      tap(page => {
        if (!page) {
          return;
        }

        switch (page.header.type) {
          case 'header-gallery':
            store.dispatch(SetMenuTheme('primary'));
            break;
          case 'header-card-slider':
            store.dispatch(SetMenuTheme('secondary'));
            break;
          case 'header-card-grid':
            store.dispatch(SetMenuTheme('secondary'));
            break;
          default:
            store.dispatch(ResetMenuTheme());
            break;
        }
        // if (page.header.type === 'header-gallery') {
        //   store.dispatch(SetMenuTheme('primary'));
        // } else {
        //   store.dispatch(ResetMenuTheme());
        // }
      }),
      filter(a => a?.id > 0),
      map(a => true),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};

export const resetHeaderThemeGuard: CanDeactivateFn<any> = () => {
  return true;
};

//export const menuThemeGuard: CanActivateFn = route => {
//  const store = inject(Store);
//  const theme = route.data['navTheme'];

//  if (theme) {
//    console.log('settring menu theme', theme);
//    store.dispatch(SetMenuTheme(theme));
//  }
//  return true;
//};

//export const resetMenuThemeGuard: CanDeactivateFn<any> = () => {
//  const store = inject(Store);
//  console.log('RESET menu theme');
//  //store.dispatch(ResetMenuTheme());
//  return true;
//};
